import React from "react";
import Tag from "../../../../generic/tag";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import { ChipColorKeyComb } from "../../obConstants";

export interface ObAssetsDetlSymProps {
	date?: string;
	trsTyp: string;
	title?: string;
	subTitle?: string;
	sts: string;
}

const ObAssetsDetlSym: React.FC<ObAssetsDetlSymProps> = (props) => {
	return (
		<div className="ob_ast_detls_con">
			<h3 className="date">{props.date}</h3>
			<div>
				<div className="tag_con ib">
					<Tag value={props.trsTyp} color={props.trsTyp === "BUY" ? "green" : "red"} shape="circle" height="60px" width="60px" />
				</div>
				<div className="comp_detail ib">
					<h2 className="title">{props.title}</h2>
					<p className="sub_tit">{props.subTitle}</p>
				</div>
				<div className="sts_cont ib">
					{props.sts && (
						<>
							<span className="sts">Status</span>
							<Tag value={props.sts} shape="chip" color={ChipColorKeyComb[props.sts]} />
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default ObAssetsDetlSym;
